import { ArrowRight, ShieldCheck, Sparkles } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { CALENDLY_URL } from "@/lib/scroll";

const Pricing = () => (
  <section
    id="pricing"
    data-testid="pricing-section"
    className="scroll-mt-24 py-20 lg:py-28"
  >
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <Reveal>
        <Eyebrow>Pricing</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 max-w-2xl font-serif text-3xl font-medium leading-[1.18] tracking-tight text-ink sm:text-4xl lg:text-5xl">
          One sprint. One flat pilot fee.
        </h2>
      </Reveal>

      <div className="mt-14 grid items-stretch gap-6 lg:grid-cols-5">
        <Reveal className="h-full lg:col-span-3">
          <div
            data-testid="pricing-card"
            className="relative h-full rounded-3xl border-2 border-ink bg-cream p-8 sm:p-12"
          >
            <span
              data-testid="pricing-badge"
              className="absolute -top-3.5 left-8 rounded-full bg-ink px-4 py-1.5 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-cream"
            >
              Pilot · First 3 founders only
            </span>

            <p className="font-mono text-xs font-semibold uppercase tracking-[0.22em] text-smokeLight">
              7-Day Sprint
            </p>
            <div className="mt-6 flex flex-wrap items-baseline gap-4">
              <span
                data-testid="pricing-price"
                className="font-serif text-6xl font-semibold tracking-tight text-ink sm:text-7xl"
              >
                $149
              </span>
              <span className="font-mono text-xs uppercase tracking-[0.18em] text-smokeLight">
                one-time · pilot price
              </span>
            </div>
            <p className="mt-4 max-w-md text-base leading-relaxed text-smoke">
              Pilot price for the first 3 founders. Everything in the sprint is
              included — research, messaging, the live proof run, tracker and
              handover.
            </p>

            <div className="mt-8 flex items-start gap-3 rounded-2xl border border-terra/20 bg-terra-soft p-5">
              <Sparkles className="mt-0.5 h-5 w-5 shrink-0 text-terra" />
              <p className="text-sm leading-relaxed text-ink">
                If you continue with a monthly program afterward, the sprint fee is
                credited toward Month 1.
              </p>
            </div>

            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="pricing-cta"
              className="mt-9 inline-flex w-full items-center justify-center gap-2 rounded-full bg-terra px-8 py-4 text-base font-medium tracking-wide text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:bg-terra-dark sm:w-auto"
            >
              Book a 15-minute fit call
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="h-full lg:col-span-2">
          <div
            data-testid="no-promise-card"
            className="flex h-full flex-col rounded-3xl border border-terra/20 bg-terra-soft p-8 sm:p-12"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white">
              <ShieldCheck className="h-6 w-6 text-terra" />
            </span>
            <h3 className="mt-8 font-serif text-2xl text-ink sm:text-3xl">
              What we don't promise
            </h3>
            <p className="mt-6 font-serif text-xl italic leading-snug text-ink">
              "We don't promise meetings or revenue from a 7-day sprint."
            </p>
            <p className="mt-4 text-sm leading-relaxed text-smoke sm:text-base">
              You get a working system, real data from a live test, and a clear view
              of whether outbound is worth scaling for your business.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Pricing;
